import { render, staticRenderFns } from "./AssetConfig.vue?vue&type=template&id=c0b34fcc"
import script from "./AssetConfig.vue?vue&type=script&lang=js"
export * from "./AssetConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports